import { IDRformat, Rpformat, Fformat } from '../lib/formatter'
import {FormatDate} from '../lib/formatDate'
export default {
    install(Vue) {
        Vue.prototype.$IDRformat = IDRformat
        Vue.prototype.$Rpformat = Rpformat
        Vue.prototype.$Fformat = Fformat
        Vue.prototype.$FormatDate = FormatDate
    }
}